export * from './dokumenten-anforderungen.component';
export * from './dokumenten-anforderungen.component.module';